import React, { useContext, useEffect, useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import PeopleIcon from "@material-ui/icons/People";
import DescriptionIcon from "@material-ui/icons/Description";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, { CChiamaWebParametri } from "src/ChiamaWeb";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { useValidationForm } from "src/hooks/Validation";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Addresses, _Button, _ButtonAPI, _CompaniesGroupDetails, _ContactDetails, _GeneralDetails } from "../components";
import { _Select } from "../form";
import { AlertDialogContext } from "../providers/AlertDialogProvider";
import { _ChangeOwners } from "../components/ClientDetails/ChangeOwners";

export const MainAddressIndex = 0;
interface IRouteParam {
    ID_Anag: string;
}

export const _ClientDetails: React.FC<Glob.IRouteGlobaleProps> = props => {
    const ID_Anag = Number(useParams<IRouteParam>().ID_Anag);
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useReducerOnChange<Dati.CRisAPIDatoTipiInfo_Anag>(new Dati.CRisAPIDatoTipiInfo_Anag());
    const [setValidateField, isValid, getFieldValidation, getFieldValidationMessage, deleteFieldValidation] = useValidationForm();

    const showCompaniesGroupDetails = Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_ATI || (Data.Dato.MandantiJSON && Data.Dato.MandantiJSON != "[]");
    const addresses = Data.Dato.IndirizziJSON ? JSON.parse(Data.Dato.IndirizziJSON) : [];
    const GiaAvvisato = useRef(false);
    const Sbloccata = useRef(false);


    useEffect(() => {
        if (!Glob.AzioneAbilitata("AnagController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
        GetDetails();
    }, [ID_Anag]);

    useEffect(() => {
        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: ID_Anag ? 10 : 0 });
    }, [ID_Anag]);

    useEffect(() => {
        if (Data.Dato.CodiceFiscale) {
            const validationType = Glob.ValidationPerControlloPIVA(Data.Dato.ID_TipoAnagPrincipale, Data.Dato.CodiceFiscale.length);
            setValidateField({ Type: validationType }, "CodiceFiscale", Data.Dato.CodiceFiscale);
        }
    }, [Data.Dato.CodiceFiscale, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale != Glob.Tipi_TAP_PersonaFisica) {
            setValidateField({ Type: "VatNumber" }, "PartitaIVA", Data.Dato.PartitaIVA);
        } else {
            deleteFieldValidation("PartitaIVA");
        }
    }, [Data.Dato.PartitaIVA, Data.Dato.ID_TipoAnagPrincipale]);


    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale != Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale != Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "RagioneSociale", Data.Dato.RagioneSociale);
        } else {
            deleteFieldValidation("RagioneSociale");
        }
    }, [Data.Dato.RagioneSociale, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "Nome", Data.Dato.Nome);
        } else {
            deleteFieldValidation("Nome");
        }
    }, [Data.Dato.Nome, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "Sesso", Data.Dato.Sesso);
        } else {
            deleteFieldValidation("Sesso");
        }
    }, [Data.Dato.Sesso, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "Cognome", Data.Dato.Cognome);
        } else {
            deleteFieldValidation("Cognome");
        }
    }, [Data.Dato.Cognome, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "FiscalCode" }, "CodiceFiscale", Data.Dato.CodiceFiscale);
        } else {
            deleteFieldValidation("CodiceFiscale");
        }
    }, [Data.Dato.CodiceFiscale, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "LuogoNascita", Data.Dato.LuogoNascita);
        } else {
            deleteFieldValidation("LuogoNascita");
        }
    }, [Data.Dato.LuogoNascita, Data.Dato.ID_TipoAnagPrincipale]);


    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaGiuridica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_Beneficiario || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_ATI) {
            setValidateField({ Type: "VatObbligatorio" }, "RagioneSociale", Data.Dato.RagioneSociale);
        } else {
            deleteFieldValidation("RagioneSociale");
        }
    }, [Data.Dato.RagioneSociale, Data.Dato.ID_TipoAnagPrincipale]);

    useEffect(() => {
        if (Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_PersonaFisica || Data.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_DittaIndividuale) {
            setValidateField({ Type: "VatObbligatorio" }, "DataNascita", Data.Dato.DataNascita);
        } else {
            deleteFieldValidation("DataNascita");
        }
    }, [Data.Dato.DataNascita, Data.Dato.ID_TipoAnagPrincipale]);

    const GetDetails = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/anag/seleziona?id_Anag=${ID_Anag}`,
            OnRis: OnGetDetails
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetDetails = (sender: ChiamaWeb, dati: Dati.CRisAPIDatoTipiInfo_Anag) => {
        if (ID_Anag && dati.Dato.ID_Anag == 0) {
            props.history.push("/anagrafica/0");
        } else {
            dati.Dato.ID_TipoAnagStato = dati.Dato.ID_TipoAnagStato || Glob.Tipi_AS_InAcquisizione;
            setData({ Type: "Set", Value: dati });
        }
    };

    const OnChangeAddresses = (val: string) => {
        const addresses = val ? JSON.parse(val) : [];
        const mainAddress = addresses[0] || {};

        setData({ Type: "OnChangeFromValue", Name: "Dato.Indirizzo", Value: mainAddress.Indirizzo || "" });
        setData({ Type: "OnChangeFromValue", Name: "Dato.IndirizziJSON", Value: val });
    };

    const OnChangeDetailsType = (valore: string) => {
        const isMainAddressRequired = valore && valore != Glob.Tipi_TAP_ATI;

        if (addresses?.length && isMainAddressRequired) {
            addresses[0].Tipo = [MainAddressIndex];
            setData({ Type: "OnChangeFromValue", Name: "Dato.IndirizziJSON", Value: JSON.stringify(addresses) });
        }
    };

    const GetFormData = (): Dati.CIngrAPITipi<Dati.CDatiAnag> => {
        let formData = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
        formData.Dato = Data.Dato;
        formData.Tipi = Data.Tipi;

        return formData;
    };

    const OnClickSave = (data: Dati.CRisAPI) => {

        const canRenew =
            Glob.GetSessione().Autorizzazioni["RenewalsController"] >= 1;

        const goToAnagraficaIfNew = () => {
            if (ID_Anag === 0) {
                props.history.push(`/anagrafica/${data.ID_Chiave}`);
            }
        };

        if (data.Errore) {
            console.warn("data.ErrTesto", data.ErrTesti[0]);

            let testoErrore = Trad.Trad(data.ErrTesto);

            if (data.ErrTesti?.length && data.ErrTesti[0] === "ErroreSanzioni") {
                testoErrore = Trad.TradParam(
                    "ErroreSanzioni:{1-S}",
                    [data.ErrTesti[1]]
                );
                props.SetDialog({
                    Open: true,
                    Title: "ANAGRAFICA ERRORE",
                    Content: testoErrore,
                    Type: "error"
                });
            }
            else if (data.ErrTesti?.length && data.ErrTesti[0] === "AnagraficaGiaPresente") {
                testoErrore = Trad.TradParam(
                    "Anagrafica presente, contattare Ufficio RCP",
                    [data.ErrTesti[1]]
                );
                props.SetDialog({
                    Open: true,
                    Title: "ANAGRAFICA ERRORE",
                    Content: testoErrore,
                    Type: "error"
                });
            }

            else if (data.ErrTesti?.length && data.ErrTesti[0] === "ErroreCodiceFiscale") {
                testoErrore = Trad.TradParam(
                    "Il codice fiscale non � valido",
                    [data.ErrTesti[1]]
                );
                props.SetDialog({
                    Open: true,
                    Title: "ANAGRAFICA ERRORE",
                    Content: testoErrore,
                    Type: "error"
                });
            }
            else if (data.ErrTesti?.length && data.ErrTesti[0] === "AnagraficaPresenteNelloStessoPortale") {
                testoErrore = Trad.TradParam(
                    "AnagraficaPresenteNelloStessoPortale",
                    [data.ErrTesti[1]]
                );
                props.SetDialog({
                    Open: true,
                    Title: "ANAGRAFICA ERRORE",
                    Content: testoErrore,
                    Type: "error"
                });
            }
            else if (GiaAvvisato.current && canRenew) {
                console.warn("data.ID_Chiave", data.ID_Chiave);
                goToAnagraficaIfNew();

                props.SetDialog({
                    Open: true,
                    Title: "ANAGRAFICA",
                    Content: Trad.TradParam(
                        "Anagrafica salvata correttamente con ID: {1-S}",
                        [data.ID_Chiave]
                    ),
                    Type: "success"
                });
            }

            GiaAvvisato.current = true;
            return;
        }

        goToAnagraficaIfNew();

        props.SetDialog({
            Open: true,
            Title: "ANAGRAFICA",
            Content: Trad.TradParam(
                "Anagrafica salvata correttamente con ID: {1-S}",
                [data.ID_Chiave]
            ),
            Type: "success"
        });

    };

    const OnError = (error: Error) => {
        props.SetDialog({ Open: true, Title: "ANAGRAFICA ERRORE", Content: error.message, Type: "error" });
        /*            ShowDialog("ANAGRAFICA ERRORE", error.message, "error");*/

    };

    const isAddressAdded = !!(addresses?.length && addresses[0].Indirizzo && addresses[0].Citta && addresses[0].Cap && addresses[0].Provincia && addresses[0].Nazione);

    let Sessione = Glob.GetSessione();
    const isCoverholder = Sessione.Gruppi.includes("7") || Sessione.Gruppi.includes("8")
        || Sessione.Gruppi.includes("9") || Sessione.Gruppi.includes("16");

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PeopleIcon} Title="Anagrafica">
                    {Glob.AzioneAbilitata("AnagController", Glob.Scrittura) && (
                        <NavLink to="/anagrafica/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <PersonAddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                    {!!ID_Anag && (
                        <a href={`/file/${ID_Anag}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="add">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <_GeneralDetails
                            Data={Data}
                            GetFieldValidation={getFieldValidation}
                            GetFieldValidationMessage={getFieldValidationMessage}
                            OnChangeDetailsType={OnChangeDetailsType}
                            OnChange={(e, val) => setData({ Type: "OnChangeFromHybrid", NameEvent: val != null && val != undefined ? e : Object.assign({}, e), Value: val })}
                        />
                        <_Addresses Data={Data.Dato.IndirizziJSON} DetailType={Data.Dato.ID_TipoAnagPrincipale} OnChange={OnChangeAddresses} />
                        <_ContactDetails Data={Data.Dato.RecapitiJSON} OnChange={val => setData({ Type: "OnChangeFromValue", Name: "Dato.RecapitiJSON", Value: val })} />
                        {showCompaniesGroupDetails && (
                            <_CompaniesGroupDetails Data={Data.Dato.MandantiJSON} OnChange={val => setData({ Type: "OnChangeFromValue", Name: "Dato.MandantiJSON", Value: val })} />
                        )}
                        <Grid container item xs={12} justify="flex-end">
                            <_ButtonAPI
                                Default
                                Attivo={isValid && isAddressAdded}
                                Hidden={!Glob.AzioneAbilitata("AnagController", Glob.Scrittura)}
                                Testo={Trad.Trad("Salva")}
                                Metodo="POST"
                                OnInvio={GetFormData}
                                OnClick={OnClickSave}
                                URL={`/api/anag/SalvaAnagraficaAsync?sbloccata=${GiaAvvisato.current}`}
                                OnErrore={OnError}
                            />
                        </Grid>
                        {isCoverholder && (<_ChangeOwners IdAnag={Data.Dato.ID_Anag} OnChange={OnChangeAddresses} />)}
                    </form>
                </_MainContent>
                <input type="hidden" id="PopupID_Anag" value={ID_Anag} />
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ClientDetails.tsx